<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
  <h1>&nbsp; > {{"admin.electronicOrdering.title" | translate}}</h1>
</div>

<section fragment="care" id="care">
  <mat-accordion>
    <mat-expansion-panel (opened)="panelCareOpenState = true" (closed)="panelCareOpenState = false"
                         [expanded]="panelCareOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{"newOrder.equipment.care.title" | translate}}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-care [ordering]="false"></app-care>
    </mat-expansion-panel>
  </mat-accordion>
</section>
<section fragment="accessories" id="accessories">
  <mat-accordion>
    <mat-expansion-panel (opened)="panelAccessoriesOpenState = true" (closed)="panelAccessoriesOpenState = false"
                         [expanded]="panelAccessoriesOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{"newOrder.equipment.accessories.title" | translate}}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-accessories [ordering]="false"></app-accessories>
    </mat-expansion-panel>
  </mat-accordion>
</section>
